import React from 'react'
import Head from 'next/head'
import Link from 'next/link'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import QuestionIcon from 'assets/icons/question.svg'
import ArrowLeftIcon from 'assets/icons/arrow-left.svg'

interface KSPSPageHeaderProps {
  title: string
  withRightActionButton?: boolean
  onBackClick?: () => void
  variant?: 'default' | 'inherit' | 'large' | 'transparent' | 'semi-transparent'
}

const KSPSPageHeader = ({
  title,
  withRightActionButton = true,
  onBackClick = null,
  variant = 'default',
}: KSPSPageHeaderProps) => {
  const headerRightHref = 'https://ksps.zendesk.com'

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <HeaderBar variant={variant}>
        <HeaderBarLeftAction onClick={() => onBackClick?.()}>
          <ArrowLeftIcon
            width={24}
            height={24}
            className="fill-current text-icon-default"
          />
        </HeaderBarLeftAction>
        <HeaderBarTitle className="capitalize">{title}</HeaderBarTitle>
        {withRightActionButton && (
          <HeaderBarRightAction>
            <Link href={headerRightHref} passHref>
              <a
                href={headerRightHref}
                className="w-[44px] h-[44px] flex items-center justify-center"
                data-testid="faq-link"
              >
                <QuestionIcon
                  width={38}
                  height={38}
                  className="fill-current text-icon-default"
                />
              </a>
            </Link>
          </HeaderBarRightAction>
        )}
      </HeaderBar>
    </>
  )
}

export default KSPSPageHeader
